import {
    DATA_DELETION_PLATFORM,
    DATA_DELETION_PLATFORMS,
    DATA_DELETION_APP_ID,
    DATA_DELETION_APP_IDS,
    DATA_DELETION_APP_LABELS,
    DATA_DELETION_APP_ID_BY_SITE_ID,
    isValidDataDeletionPlatform,
    isValidDataDeletionAppId,
    readDataDeletionPlatform,
    readDataDeletionAppId,
} from "../../../config/dataDeletionAppId";
import { resolvePublicSiteOrigin } from "../../../config/appSiteLinks";

export const DATA_DELETION_REQUEST_PATH = "/data-deletion/request";

export {
    DATA_DELETION_PLATFORM,
    DATA_DELETION_PLATFORMS,
    DATA_DELETION_APP_ID,
    DATA_DELETION_APP_IDS,
    DATA_DELETION_APP_LABELS,
    DATA_DELETION_APP_ID_BY_SITE_ID,
    isValidDataDeletionPlatform,
    isValidDataDeletionAppId,
    readDataDeletionPlatform,
    readDataDeletionAppId,
};

/**
 * Build a shareable URL for the data deletion request page.
 * @param {string} [origin]
 * @param {{ platform?: string, appId?: string }} [options]
 * Optional `platform=google`, `platform=apple`, `platform=amazon`, or `platform=samsung`,
 * and `appId=word-wheel-quest`.
 */
export function buildDataDeletionRequestUrl(
    origin = typeof window !== "undefined" ? window.location.origin : "",
    { platform, appId } = {},
) {
    const base = `${origin}${DATA_DELETION_REQUEST_PATH}`;
    const params = new URLSearchParams();
    if (isValidDataDeletionPlatform(platform)) {
        params.set("platform", platform.trim());
    }
    if (isValidDataDeletionAppId(appId)) {
        params.set("appId", appId.trim());
    }
    const query = params.toString();
    return query ? `${base}?${query}` : base;
}

/** Public deletion URL for store listings (uses the current origin when on the site). */
export function resolvePublicDataDeletionRequestUrl({ platform, appId } = {}) {
    return buildDataDeletionRequestUrl(resolvePublicSiteOrigin(), { platform, appId });
}

/**
 * Google Play, App Store, Amazon Appstore, and Galaxy Store deletion URLs for a site app
 * (`word_wheel_quest`, …).
 * @returns {Array<{ platform: string, label: string, url: string }>}
 */
export function resolvePublicDataDeletionLinksForSiteApp(siteAppId) {
    const deletionAppId = DATA_DELETION_APP_ID_BY_SITE_ID[siteAppId];
    if (!deletionAppId) return [];
    return [
        {
            platform: DATA_DELETION_PLATFORM.GOOGLE,
            label: "Data deletion (Google Play)",
            url: resolvePublicDataDeletionRequestUrl({
                platform: DATA_DELETION_PLATFORM.GOOGLE,
                appId: deletionAppId,
            }),
        },
        {
            platform: DATA_DELETION_PLATFORM.APPLE,
            label: "Data deletion (App Store)",
            url: resolvePublicDataDeletionRequestUrl({
                platform: DATA_DELETION_PLATFORM.APPLE,
                appId: deletionAppId,
            }),
        },
        {
            platform: DATA_DELETION_PLATFORM.AMAZON,
            label: "Data deletion (Amazon)",
            url: resolvePublicDataDeletionRequestUrl({
                platform: DATA_DELETION_PLATFORM.AMAZON,
                appId: deletionAppId,
            }),
        },
        {
            platform: DATA_DELETION_PLATFORM.SAMSUNG,
            label: "Data deletion (Galaxy Store)",
            url: resolvePublicDataDeletionRequestUrl({
                platform: DATA_DELETION_PLATFORM.SAMSUNG,
                appId: deletionAppId,
            }),
        },
    ];
}
